import React from 'react';

import styled from 'styled-components';

const Title = styled.div`
  font-family: var(--font-regular);
  font-size: 14px;
`;

const Subtitle = styled.div`
  color: var(--text-secondary);
  font-size: 12px;
`;

type Props = { contract: any; expandedRowKeys: string[]; rowKey: string; dataTestId?: string };

const CMASummaryTableDataContract = ({ contract, expandedRowKeys, rowKey, dataTestId }: Props) => {
  if (!contract || !contract.length || !expandedRowKeys.includes(rowKey)) {
    return null;
  } else if (contract[0] === undefined || contract[0] === null) {
    return <Title data-test-id={dataTestId}>-</Title>;
  }

  return (
    <div data-test-id={dataTestId}>
      <Title>{contract[0]}</Title>
      {contract[1] && <Subtitle>{contract[1]}%</Subtitle>}
    </div>
  );
};

export default CMASummaryTableDataContract;
